import React, { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import '../FriendAndFamily/MyStyles/style.css';
import '../FriendAndFamily/MyStyles/responsive.css';
import ErrorIcon from '@mui/icons-material/Error';
import Loader from '../../Utilities/Loader'

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const VZYPaymentStatus = () => {

    const [searchParams] = useSearchParams();
    const queryValue = searchParams.get('SessionID');

    const [failedStatusCount, setFailedStatusCount] = useState(0);
    const [paymentStatus, setPaymentStatus] = useState("Pending");
    const [firstLoad, setFirstLoad] = useState(true);


    const getPaymentStatus = () => {
        const req = {
            OrderID: queryValue
        }

        fetch(`${apiBaseURL}/api/FriendAndFamily/PaymentAcknowledgmentForWatcho`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(req)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(resultInfo => {
                setFirstLoad(false);
                if (resultInfo && resultInfo.resultStatus === "Success") {
                    setPaymentStatus("Success");
                }
                else if (resultInfo && resultInfo.resultStatus === "Failed") {
                    setFailedStatusCount((prv) => prv + 1);
                    setPaymentStatus("Failed");
                }
                else if (resultInfo && resultInfo.resultStatus === "Pending") {
                    setFailedStatusCount((prv) => prv + 1);
                    setPaymentStatus("Pending");
                }
            })
            .catch(err => {
                console.error("Error calling GenerateBulkSubscriptionRequest API:", err);

            });
    }


    useEffect(() => {

        if (firstLoad) {
            getPaymentStatus(searchParams)
        }
        if ((paymentStatus === "failed" || paymentStatus === "pending") && failedStatusCount <= 6) {
            setTimeout(() => {
                getPaymentStatus(searchParams)
            }, 10000)
        }

    }, [failedStatusCount]);

    return (<>
        {firstLoad ?
            <Loader showLoading={firstLoad} />
            : <div className="containerThankuMain">
                {paymentStatus === "Success" && <>
                        <div>
                            <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                                <div className="container-fluid mobile-res-clss">
                                    <a className="navbar-brand custom-logo" href="https://vzy.one/">
                                        <img src="/Images/logo.svg" alt="MyLogo" className="img-fluid clas-of-logo" />
                                    </a>
                                </div>
                            </nav>

                            <div className="container my-5">
                                <div className="text-center">
                                    <div className="congrats-container-fornew">
                                        <div className="check-icon">
                                            <img src="/Images/Group 39.png" alt="success" />
                                        </div>
                                        <h2>Congratulations!</h2>
                                        <h3>Your payment was successful!</h3>
                                        <p className="text-muted-corporate-voucher">Thank you for your payment. We will be in contact with more details shortly.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </>
                }
                {paymentStatus === "Failed" &&
                    <div>
                        <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                            <div className="container-fluid mobile-res-clss">
                                <a className="navbar-brand custom-logo" href="https://vzy.one/">
                                    <img src="/Images/logo.svg" alt="My Logo" className="img-fluid clas-of-logo" />
                                </a>
                            </div>
                        </nav>
                        <div className="container my-5">
                            <div className="text-center">
                                <div className="congrats-container-img">
                                    <div className="check-icon-img">
                                        <img src="/Images/error.png" alt="error" />
                                    </div>
                                    <h2>Oops! Payment Failed</h2>
                                    <h3>We are unable to process your payment</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {paymentStatus === "Pending" &&
                    <div>
                        <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                            <div className="container-fluid mobile-res-clss">
                                <a className="navbar-brand custom-logo" href="https://vzy.one/">
                                    <img src="/Images/logo.svg" alt="My Logo" className="img-fluid clas-of-logo" />
                                </a>
                            </div>
                        </nav>
                        <div className="container my-5">
                            <div className="text-center">
                                <div className="congrats-container-pending">
                                    <div className="check-icon-img">
                                        <ErrorIcon sx={{ color: "#f5ae00", fontSize: "100px", backgroundColor: "#fff", borderRadius:"50px"  }} />
                                    </div>
                                    <h2>Payment Pending</h2>
                                    <h3>Your payment is pending. Please wait while we get status of your payment.</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </>
    );
}